"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.iconMap = exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _AttachmentAudio = _interopRequireDefault(require("../Icons/AttachmentAudio"));
var _AttachmentBook = _interopRequireDefault(require("../Icons/AttachmentBook"));
var _AttachmentCalendar = _interopRequireDefault(require("../Icons/AttachmentCalendar"));
var _AttachmentCode = _interopRequireDefault(require("../Icons/AttachmentCode"));
var _AttachmentDoc = _interopRequireDefault(require("../Icons/AttachmentDoc"));
var _AttachmentFont = _interopRequireDefault(require("../Icons/AttachmentFont"));
var _AttachmentImage = _interopRequireDefault(require("../Icons/AttachmentImage"));
var _AttachmentPdf = _interopRequireDefault(require("../Icons/AttachmentPdf"));
var _AttachmentPresentation = _interopRequireDefault(require("../Icons/AttachmentPresentation"));
var _AttachmentSpreadsheet = _interopRequireDefault(require("../Icons/AttachmentSpreadsheet"));
var _AttachmentVideo = _interopRequireDefault(require("../Icons/AttachmentVideo"));
var _AttachmentArchive = _interopRequireDefault(require("../Icons/AttachmentArchive"));
var _AttachmentOther = _interopRequireDefault(require("../Icons/AttachmentOther"));
var _constants = require("../../utils/constants");
var _utils = require("../../utils");
var _excluded = ["colored", "contentType", "fileName", "style", "attachmentType", "customColor"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var iconMap = exports.iconMap = {
  audio: _AttachmentAudio["default"],
  book: _AttachmentBook["default"],
  calendar: _AttachmentCalendar["default"],
  code: _AttachmentCode["default"],
  doc: _AttachmentDoc["default"],
  font: _AttachmentFont["default"],
  image: _AttachmentImage["default"],
  pdf: _AttachmentPdf["default"],
  presentation: _AttachmentPresentation["default"],
  spreadsheet: _AttachmentSpreadsheet["default"],
  video: _AttachmentVideo["default"],
  archive: _AttachmentArchive["default"],
  other: _AttachmentOther["default"]
};
var AttachmentIcon = function AttachmentIcon(_ref) {
  var _ref$colored = _ref.colored,
    colored = _ref$colored === void 0 ? false : _ref$colored,
    contentType = _ref.contentType,
    fileName = _ref.fileName,
    style = _ref.style,
    attachmentType = _ref.attachmentType,
    _ref$customColor = _ref.customColor,
    customColor = _ref$customColor === void 0 ? '' : _ref$customColor,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var iconType = attachmentType || (0, _utils.getAttachmentType)(contentType, fileName);
  var color = customColor || _constants.attachmentCategoryMap[iconType].color;
  var Icon = iconMap[iconType] || _AttachmentOther["default"];
  return /*#__PURE__*/_react["default"].createElement(Icon, (0, _extends2["default"])({}, rest, {
    style: _objectSpread(_objectSpread({}, style), {}, {
      fill: colored ? color : 'var(--color-bg-primary)'
    })
  }));
};
var _default = exports["default"] = AttachmentIcon;
//# sourceMappingURL=index.js.map